export const DEGREE_OPTIONS = [
  {
    value: "Master",
    label: "ارشد",
  },
  {
    value: "P.H.D",
    label: "دکترا",
  },
];

export const APPLICATION_OPTIONS = [
  { value: "Not_Completed", label: "تکمیل نشده" },
  { value: "Current", label: "در حال بررسی" },
  { value: "Accepted", label: "تایید شده" },
  { value: "Rejected", label: "رد شده" },
  { value: "Need_To_Edit", label: "نیاز به ویرایش" },
];

export const GENDER_OPTIONS = [
  {
    value: "",
    label: "تفاوتی ندارد",
  },
  {
    value: "Female",
    label: "خانم",
  },
  {
    value: "Male",
    label: "آقا",
  },
];

export const STAFF_ROLE_OPTIONS = [
  {
    value: "superuser",
    label: "ادمین کل",
  },
  {
    value: "faculty_director",
    label: "معاون آموزشی دانشکده",
  },
  {
    value: "department_head",
    label: "مدیر گروه",
  },
  {
    value: "department_member",
    label: "عضو هیئت علمی",
  },
];

export const YEAR_SEASON_OPTIONS = [
  {
    value: "Spring",
    label: "بهار ",
  },
  {
    value: "Summer",
    label: "تابستان ",
  },
  {
    value: "Fall",
    label: "پائیز ",
  },
  {
    value: "Winter",
    label: "زمستان ",
  },
];

export const APPLICATION_STATUS = [
  {
    value: "Need_To_Edit",
    label: "نیاز به ویرایش",
  },
  {
    value: "Rejected",
    label: "رد",
  },
  {
    value: "Accepted",
    label: "تایید",
  },
];
